import { AlertBanner, Button, Group } from '@grovus/design-system'
import type { Notice } from '../auth/entry'
import { MEMBERS_COPY, type Lang } from '../i18n'
import { fmt } from '../lib/format'

interface Props {
  lang: Lang
  notice: Notice
  /** "Switch to <client>" on the joined notice; the only way that notice changes the company. */
  onSwitch: (companyId: string) => void
  onDismiss: () => void
}

/** What the boundary says after a transition it made (plan, Task 6.4): a company joined, or the active one lost. */
export function TransitionNotice({ lang, notice, onSwitch, onDismiss }: Props) {
  const copy = MEMBERS_COPY[lang]
  const text = notice.kind === 'joined'
    ? fmt(copy.joined, { name: notice.name, role: copy.roles[notice.role] })
    : fmt(copy.lost, { lost: notice.lostName, next: notice.nextName })
  return (
    <div role="status" data-testid="transition-notice" style={{ marginBottom: 16 }}>
      <AlertBanner
        tone="info"
        action={(
          <Group gap={8} wrap="nowrap">
            {notice.kind === 'joined' && (
              <Button variant="default" onClick={() => onSwitch(notice.companyId)}>
                {fmt(copy.switchTo, { name: notice.name })}
              </Button>
            )}
            <Button variant="subtle" onClick={onDismiss}>{copy.dismiss}</Button>
          </Group>
        )}
      >
        {text}
      </AlertBanner>
    </div>
  )
}
